export default __webpack_public_path__ + "static/media/235.ad9a5c40.svg";